import path from "path"

export interface NetworkConfig {
  apiHost: string
  renderingHost: string
  sceneTreeHost: string
  sceneViewHost: string
}

export interface CredentialsConfig {
  clientId?: string
  clientSecret?: string
  redisSecret?: string
  redisHost?: string
  redisPort?: number
}

export interface StreamCredentials {
  readonly sceneId: string
  readonly clientId: string
  readonly streamKey: string
  readonly sceneViewStateId?: string
  readonly sceneViewSuppliedId?: string
}

export interface Config {
  baseUrl: string
  network: NetworkConfig
  credentials: CredentialsConfig
  defaultCatalog?: string
  publicDir: string
}


let _baseUrl:string;
export const getBaseUrl = ():string => {
  if (_baseUrl == null) {
    return getEnvVar('VERCEL_URL') ? `https://${getEnvVar('VERCEL_URL')}` : `http://localhost:3000`;
  } else {
    return _baseUrl;
  }
}
export const setBaseUrl = (baseUrl: string) => {
  _baseUrl = baseUrl;
};

export const defaultNetworkConfiguration: NetworkConfig = {
  apiHost: 'https://platform.vertexvis.com',
  renderingHost: 'wss://stream.platprod.vertexvis.io',
  sceneTreeHost: 'https://scene-trees.platprod.vertexvis.io',
  sceneViewHost: 'https://scenes.platprod.vertexvis.io',
}

export const isServer = () => typeof window === 'undefined';

export function getConfiguration(): Config {
  return {
    baseUrl: getBaseUrl(),
    network: {
      apiHost:
        getEnvVar('VERTEX_API_HOST') ?? defaultNetworkConfiguration.apiHost,
      renderingHost:
        getEnvVar('VERTEX_RENDERING_HOST') ??
        defaultNetworkConfiguration.renderingHost,
      sceneTreeHost:
        getEnvVar('VERTEX_SCENE_TREE_HOST') ??
        defaultNetworkConfiguration.sceneTreeHost,
      sceneViewHost:
        getEnvVar('VERTEX_SCENE_VIEW_HOST') ??
        defaultNetworkConfiguration.sceneViewHost,
      },
    credentials: {
      clientId: getEnvVar('VERTEX_CLIENT_ID'),
      clientSecret: getEnvVar('VERTEX_CLIENT_SECRET'),
      redisSecret: getEnvVar('REDIS_SECRET'),
      redisHost: getEnvVar('REDIS_HOST'),
      redisPort: Number(getEnvVar('REDIS_PORT') ?? "6379"),
    },
    defaultCatalog: getEnvVar('VERTEX_DEFAULT_CATALOG'),
    publicDir: path.join(process.cwd(), `/public`),
  }
}

function getEnvVar(name: string): string | undefined {
  const value = process.env[name]

  return (value != null && value !== '') ? value : undefined
}
